import { render, staticRenderFns } from "./waterStandard.vue?vue&type=template&id=686254dc"
import script from "./waterStandard.vue?vue&type=script&lang=js"
export * from "./waterStandard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports